/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.StLouisFunds.Title',
    defaultMessage: 'St. Louis Funds',
  },
});

export default messages;
